import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import { EnhanceWidget, fetchDataSource } from "@jdwork/jdwork-sdk";

import ZeusBanner from "@/widgets/zeus_banner";
import ZeusBannerData from "./data/zeus_banner/data";

import ZeusSolutionAbilityDetail2933 from "@/widgets/zeus_solution_ability_detail2933";
import ZeusSolutionAbilityDetail2933Data from "./data/zeus_solution_ability_detail2933/data";

import ZeusHomepageFloatRightbar1817 from "@/widgets/zeus_homepage_float_rightbar1817";
import ZeusHomepageFloatRightbar1817Data from "./data/zeus_homepage_float_rightbar1817/data";

class Home extends React.Component {
  dataSourceMap: Record<string, any>;
  constructor(props) {
    super(props);
    this.dataSourceMap = new Map();
  }
  componentDidMount() {
    this.dataSourceMap.size > 0 && fetchDataSource(this.dataSourceMap);
  }
  render() {
    const { dataSourceMap } = this;
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_banner" data-version="2.0.1">
                <ZeusBanner {...ZeusBannerData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container" style={{ backgroundColor: "#fafafa" }}>
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_solution_ability_detail" data-version="2.2.3">
                <EnhanceWidget
                  config={{ ...ZeusSolutionAbilityDetail2933Data }}
                  dataSourceMap={dataSourceMap}
                  widget={ZeusSolutionAbilityDetail2933}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_homepage_float_rightbar" data-version="1.2.1">
                <ZeusHomepageFloatRightbar1817 {...ZeusHomepageFloatRightbar1817Data} />
              </div>
            </div>
          </div>
        </div>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
